<button (click)="modalDelete()" type="button" class="btn btn-danger" title="Esvaziar Carrinho">
  <i class="material-icons">&#xE872;</i>
  <span class="text">Esvaziar Mochila</span>
</button>